import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BundleConfiguration } from '@core/core.types';
import { environment } from '@root/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BundleConfigurationService {
  private http = inject(HttpClient);

  private apiUrl = `${environment.apiUrl}/bundle-configuration`;

  public getBundleConfigurationById(
    bundleConfigurationId: string
  ): Observable<BundleConfiguration> {
    return this.http.get<BundleConfiguration>(
      `${this.apiUrl}/${bundleConfigurationId}`
    );
  }
}
